<!--

	Panel which displays bullet points about our accessibility features

-->
<template>
	<div class="mia-AccessibilityInfoPanel">
		<div class="mia-accessibilityInfoColumns">
			<div class="mia-accessibility-info-column">
				<h1 v-tr="'accessibility_info_panel_title'" class="mia-Heading" />
				<h3 v-tr="'accessibility_info_panel_subtitle'" />
				<div v-for="(infoPoint, index) in infoPoints" :key="index" class="mia-accessibility-info-point">
					<responsive-image :from="infoPoint.IconUrl" class="mia-accessibility-icon" />
					<span v-tr="infoPoint.MessageTextResource" class="mia-accessibility-icon-comment" />
				</div>
			</div>
			<div class="mia-accessibility-picture-columm">
				<responsive-image :from="mainImg" />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import ResponsiveImage from "@/Control/Vue/ResponsiveImage";
import LearnersMindPicture from "@theme/parents/landingpage/learners_mind.svg?inline";
import TimersIcon from "@theme/parents/landingpage/icons/icon_timer.svg?inline";
import VideoIcon from "@theme/parents/landingpage/icons/icon_video.svg?inline";
import LessonOptionsIcon from "@theme/parents/landingpage/icons/icon_lesson_option.svg?inline";
import SuplementalsIcon from "@theme/parents/landingpage/icons/icon_supplemental_materials.svg?inline";
import CurriculumIcon from "@theme/parents/landingpage/icons/icon_curriculum.svg?inline";

@Component({
	components: { ResponsiveImage },
})
export class AccessibilityInfoPanel extends Vue {
	get infoPoints(): InfoBulletPoint[] {
		return [{
				IconUrl: TimersIcon,
				MessageTextResource: "accessibility_info_panel_optional_timers"
			}, {
				IconUrl: VideoIcon,
				MessageTextResource: "accessibility_info_panel_engaging_videos"
			}, {
				IconUrl: LessonOptionsIcon,
				MessageTextResource: "accessibility_info_panel_read_aloud_feature"
			}, {
				IconUrl: SuplementalsIcon,
				MessageTextResource: "accessibility_info_panel_suplemental_materials"
			}, {
				IconUrl: CurriculumIcon,
				MessageTextResource: "accessibility_info_panel_personalized_curriculum"
			},
		] as InfoBulletPoint[];
	}

	get mainImg(): string {
		return LearnersMindPicture;
	}
}

interface InfoBulletPoint {
	IconUrl: string,
	MessageTextResource: string,
}

export default toNative(AccessibilityInfoPanel);
</script>
<style lang="scss">
.mia-AccessibilityInfoPanel {
	padding-bottom: theme.$mia-padding-panel;

	&::before {
		content: "";
		display: block;
		margin-bottom: theme.$mia-margin-size-huge;
	}

	.mia-accessibilityInfoColumns {
		display: flex;
		justify-content: space-evenly;
		align-items: center;

		@media (max-width: theme.$screen-sm-max) {
			flex-direction: column;
			align-items: center;
			margin-left: 3%;

			.mia-Heading {
				text-align: left;
			}
		}

		.mia-accessibility-info-column {
			flex-basis: 50%;

			@media (max-width: theme.$screen-sm-max) {
				flex-basis: 90%;
			}

			.mia-accessibility-info-point {
				display: flex;
				align-items: center;

				.mia-accessibility-icon {
					margin-right: theme.$mia-margin-size-xl;
				}

				.mia-accessibility-icon-comment {
					font-size: theme.$font-size-h4;
					width: 100%;
				}
			}
		}

		.mia-accessibility-picture-columm {
			flex-basis: 30%;

			@media (max-width: theme.$screen-sm-max) {
				flex-basis: 90%;
				&::before{
					content: "";
					display: block;
					margin-bottom: theme.$mia-margin-size-huge;
				}
			}
		}
	}
}
</style>
